import React from 'react';
import PropTypes from 'prop-types';
import InputField from 'components/InputField/InputField';
import Icon from 'material-ui/Icon';
import AddIcon from 'material-ui-icons/Add';
import Button from 'material-ui/Button';

const NewQuiz = ({
    onChange,
    quizzes,
    onAddElement,
    onRemoveElement,
  }) => {
  return (
    <div className="add_cpd">
      <h3>CPD Quiz </h3>
      {quizzes.map((quiz, index) => (
        <div className="section_form_cpd row" key={quiz.__id}>
          <Icon onClick={() => onRemoveElement(quiz.__id)} className="remove_question">close</Icon>
          <h5>Question {index + 1}</h5>

            <InputField
              field_name='question'
              label='Question'
              onChange={(e) => (onChange(quiz.__id, 'question', e.target.value))}
              value={quiz.question}
              className="col s12"
            />

          <p className="col s6" onClick={() => onChange(quiz.__id, 'correct', true)}>
            <input name={`group${quiz.__id}` } type="radio" id={`Questiontrue${quiz.__id}`}
              checked={quiz.correct}
              value='trueOption'
            />
            <label for={`Questiontrue${quiz.__id}`}>True</label>
          </p>

          <p className="col s6" onClick={() => onChange(quiz.__id, 'correct', false)}>
            <input name={`group${quiz.__id}`} type="radio" id={`Questionfalse${quiz.__id}`}
              checked={!quiz.correct}
              value='falseOption'
            />
            <label for={`Questionfalse${quiz.__id}`}>False</label>
          </p>

        </div>
      ))}
      <a className="add_option" onClick={onAddElement} href="javascript:void(0)">
        Add another option
      </a>
    </div>
  );
}

NewQuiz.defaultProps = {};

NewQuiz.propTypes = {
  onChange: PropTypes.func,
  onAddElement: PropTypes.func,
  onRemoveElement: PropTypes.func,
  quizzes: PropTypes.array
};

export default NewQuiz;



/** WEBPACK FOOTER **
 ** ./src/components/Admin/Quiz/NewQuiz.jsx
 **/